import React, {Component} from "react";
import NPOPicture from "../atoms/NPOPicture";
import {Button} from "../atoms/Button";
import SvgArrowForward from "../icons/ArrowForward";
import SvgCalendar from "../icons/SvgCalendar";
import SvgPin from "../icons/SvgPin";
import SvgSchool from "../icons/categories/SvgSchool";
import SvgStudy from "../icons/SvgStudy";
import SvgEditNote from "../icons/SvgEditNote";
import SvgTrash from "../icons/SvgTrash";

class ProfileEducationItem extends Component {

    render() {
        const item = this.props.item
        const index = this.props.index
        return (
            <div
                className={`flex flex-col gap-3 border-b border-slate-200 last:border-transparent last:pb-0 py-5`}
                key={item.domain}
                style={{}}
                onError={(e) => {
                    e.target.src =
                        "https://handshake-production-cdn.joinhandshake.com/static_assets/default_institution_1.png";
                    this.setState({imageError: true});
                }}
                >
                <div className='flex flex-row flex-1 items-center justify-between gap-2'>
                    <NPOPicture
                        logoUrl={item.logo_url}
                        np={item}
                        size={64}
                        className={'border min-w-[64px] border-slate-200'}
                    />
                    <div className='col-plain flex flex-1 truncate' style={{textAlign: "left"}}>
                        <p className='text-xl font-semibold'>
                            {item.name}
                        </p>
                        {/* <div className='flex flex-row items-center gap-2 text-slate-500'>
                            <SvgPin className={'w-4 h-4'}/>
                            <p className='font-semibold text-lg truncate'>
                                {'Cambridge, MA'}
                            </p>
                        </div> */}
                        {!!item.major &&
                            <div className='flex flex-row items-center text-slate-500'>
                                <SvgStudy className={'w-5 h-5'}/>
                                <p className='font-semibold ml-4'>
                                    {item.major}
                                </p>
                            </div>
                        }
                    </div>
                    <div className='flex flex-row items-center gap-3'>
                        {this.props.editing ?
                            <Button size={'icon'} variant={'secondary'} onClick={() => this.props.onClickEdit(item)}>
                                <SvgEditNote/>
                            </Button>
                            :
                            null
                        }
                        {this.props.editing &&
                            <Button size={'icon'} variant={'destructive'} onClick={() => this.props.onClickDelete(item.domain)}>
                                <SvgTrash/>
                            </Button>
                        }
                    </div>
                </div>
                <div className='flex flex-col flex-1 gap-1'>
                    <div className="flex flex-row gap-5">
                        <div className='flex flex-row items-center text-slate-500'>
                            <SvgCalendar className={'w-5 h-5'}/>
                            <p className='font-semibold ml-4'>
                                Started {item.start_date}
                            </p>
                        </div>
                        <div className='flex flex-row items-center text-slate-500'>
                            <SvgSchool className={'w-5 h-5'}/>
                            <p className='font-semibold ml-4'>
                                Class of {item.end_date}
                            </p>
                        </div>
                    </div>
                    <p className='text-slate-700 w-full mt-1 text-lg'>
                        {item.connection}
                    </p>
                </div>
            </div>
        )
    }
}

export default ProfileEducationItem
